import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

import RestaurantModal from '../../Restaurant/RestaurantModal'

//Utils 
import { RenderIf } from '../../../utils/RenderIf';
import ModalLanguage from '../../common/Header/ModalLanguage';
import LanguageSwitcher from '../../common/Header/LanguageSwitcher';
import SubMenuNav from '../../Menu/SubMenu/SubMenuNav ';
import toggleFullScreen from '../../../utils/ToggleFullScreen';

import Theme from './Theme';
import PrtsNavbar from './PrtsNavbar';
//css
import './header.css';
import BtnShoppingcartFloat from '../../../utils/BtnShoppingcartFloat';
import EventSelector from '../../EventSelector/EventSelector';
import { buildCloudinaryImageUrl } from "../../../utils/CloudinaryImageUrl";
import { useTableSession } from '../../../context/TableSessionContext';
import ContextBar from './ContextBar';
const DIRECT_ORDER_CONTEXT_CLEARED_EVENT = "checkout:direct-order-context-cleared";

const HeaderMain = ({ type, shoppingcart, shoppingCartCombos, themeinit, buttonShopavailable, quoteData, headerenabledOpcionLimit, showDirectOrderContext = false }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { quote, code, PreOrder_idP, keyproduct } = useParams();
    const { hasTableSession } = useTableSession();

    const [businessCode, setbusinessCode] = useState(() => {
        if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
            return JSON.parse(localStorage.getItem("business")).code
        }
    });

    const [branchoffice_code, setbranchoffice_code] = useState(() => {
        if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
            return JSON.parse(localStorage.getItem("branchoffice")).code
        }
    });
    const [machine_code_table, setmachine_code_table] = useState(() => {
        if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
            return JSON.parse(localStorage.getItem("machine")).code
        }
    });

    const [clientData, setClientData] = useState(() => {
        if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
            return JSON.parse(localStorage.getItem('client'))
        } else {
            return null
        }
    })

    const [guestClient, setGuestClient] = useState(() => {
        if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
            return localStorage.getItem('guestClient')
        } else {
            return null
        }
    });

    const [PreOrder_id, setPreOrder_id] = useState(() => {
        if (localStorage.getItem('PreOrder') != null && localStorage.getItem('PreOrder') != undefined && localStorage.getItem('PreOrder') != '') {
            return localStorage.getItem('PreOrder')
        } else {
            return null
        }
    });

    const [PreOrder_Code, setPreOrder_Code] = useState(() => {
        if (localStorage.getItem('PreOrderCode') != null && localStorage.getItem('PreOrderCode') != undefined && localStorage.getItem('PreOrderCode') != '') {
            return localStorage.getItem('PreOrderCode')
        } else {
            return null
        }
    });

    useEffect(() => {
        const syncDirectOrderContext = () => {
            setPreOrder_id(localStorage.getItem('PreOrder') || null);
            setPreOrder_Code(localStorage.getItem('PreOrderCode') || null);
        };

        window.addEventListener('storage', syncDirectOrderContext);
        window.addEventListener(DIRECT_ORDER_CONTEXT_CLEARED_EVENT, syncDirectOrderContext);

        return () => {
            window.removeEventListener('storage', syncDirectOrderContext);
            window.removeEventListener(DIRECT_ORDER_CONTEXT_CLEARED_EVENT, syncDirectOrderContext);
        };
    }, []);



    const [modalShow, setModalShow] = React.useState(false);
    const [shop, setShop] = useState(() => {
        if (localStorage.getItem("shop") != "" && localStorage.getItem("shop") != undefined) { return true } else { return false }
    });
    let logo = localStorage.getItem('logo')
    let brachoffice_name = ''
    let codeTable = ''

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const menuType = queryParams.get('type');


    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        brachoffice_name = branchoffice.name
    }

    let countProduct = 0
    if (shoppingcart != undefined) {
        shoppingcart.forEach((product) => {
            countProduct = (countProduct + parseInt(product.amount))
        });
    }

    if (shoppingCartCombos != undefined) {
        shoppingCartCombos.forEach((product) => {
            countProduct = (countProduct + parseInt(product.amount))
        });
    }




    //Bussines Information 
    let business = "";
    if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {
    } else {
        business = JSON.parse(localStorage.getItem("business"));
    }





    const [theme, setTheme] = useState('light');

    // Leer el tema desde localStorage al iniciar
    useEffect(() => {
        let themeload = theme;
        if (themeinit !== undefined || themeinit !== null || themeinit !== "") {
            themeload = themeinit;
        }
        const savedTheme = localStorage.getItem('theme') || themeload;
        setTheme(savedTheme);
        document.documentElement.setAttribute('data-theme', savedTheme);
    }, [themeinit]);

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
    };


    const [scrollEffect, setScrollEffect] = useState(0);
    const [navScrolled, setNavScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const effect = Math.min(scrollY / 300, 1);
            setScrollEffect(effect);

            if (scrollY > 50) {
                setNavScrolled(true);
            } else {
                setNavScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    //** Information and validation of data general Bussiness

    let primaryColor = "#000000"; // Default primary color
    let secondaryColor = "#000000"; // Default primary color

    const generalDataBs = localStorage.getItem("generalData");


    if (generalDataBs) {
        const parsedData = JSON.parse(generalDataBs);


        let configurationBs = parsedData[0].data.configuration

        primaryColor = configurationBs.containerColor
        secondaryColor = configurationBs.layaoutColor


        // Pasar a variables CSS en :root
        const root = document.documentElement;
        root.style.setProperty("--color-primary", configurationBs.containerColor);
        root.style.setProperty("--color-secondary", configurationBs.layaoutColor);

    }

    //! End JS Information and validation of data general Bussiness

    // Serializamos el JSON cada vez que cambie el color
    const attrs = useMemo(
        () =>
            JSON.stringify({
                variationThumbColour: "#FFFFFF",
                variationName: "Normal",
                variationNumber: 1,
                numberOfGroups: 1,
                backgroundIsGroup: false,
                strokeWidth: 2,
                defaultColours: {
                    "group-1": primaryColor,
                    background: "#FFFFFF00",
                },
            }),
        [primaryColor]
    );



    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const closeMenu = () => setMenuOpen(false);

    const menuOptions = [
        { label: t('nav.home'), path: '/', icon: 'bi bi-house-door' },
        { label: t('nav.products'), path: '/menu', icon: 'bi bi-grid-3x3-gap' },
        // { label: t('nav.about'), path: '/about', icon: 'uil uil-store' },
        { label: t('nav.orders'), path: '/orders', icon: 'bi bi-bag-check' },
        // { label: 'Cupones', path: '/', icon: 'uil uil-pricetag-alt' },
        // { label: 'Puntos', path: '/', icon: 'uil uil-coins' },
        { label: t('nav.contact'), path: '/contact', icon: 'bi bi-headset' },
        ...(hasTableSession ? [{ label: t('nav.viewMyOrder'), path: '/cart', icon: 'bi bi-receipt' }] : []),

    ];

    const hideNavbarRoutes = ["/branch/select/true", "/branch"];

    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

    const Ico = {
        Home: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
        Menu: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /></svg>,
        Orders: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>,
        Phone: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>,
        Pin: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>,
        User: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
        Star: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
        Cart: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>,
        Sun: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /></svg>,
        Moon: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>,
        Globe: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>,
        X: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
    };

    return (
        <>
            {/* New Version Navbar */}
            <nav className={`dn-nav`}>
                {/* ── IZQUIERDA: logo + context chips ── */}
                <div className="dn-left">
                    {/* <button className="dn-logo">

                        <img src={logo}
                            alt="Logo Bussiness" className='logo-img' /></button> */}

                    <div className="logo-container">
                        {/* <img src={logo} class="logo-img" /> */}
                        <img className="logo-img"
                            src={buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" })}
                            onError={e => e.target.style.opacity = 0}
                        />
                    </div>
                    <span className="dn-vline" />
                    {showDirectOrderContext && !shouldHideNavbar ? (
                        <button className="dn-ctx border" type="button">
                            <Ico.Pin />
                            <span className="dn-ctx-label">{t('nav.branch')}</span>
                            <span className="dn-ctx-val">{brachoffice_name}</span>
                        </button>
                    ) : PreOrder_id !== null ?
                        <></>
                        : !shouldHideNavbar && <>

                            <NavLink
                                className="text-decoration-none me-lg-1" to={`/branch/select/${true}`}>
                                <RestaurantModal brachoffice_name={brachoffice_name} primaryColor={primaryColor} />
                            </NavLink>


                        </>
                    }


                    {!shouldHideNavbar && (clientData !== null || showDirectOrderContext) && (

                        showDirectOrderContext ? (
                            <button className="dn-ctx border" type="button">
                                <Ico.User />
                                <span className="dn-ctx-label">{t('nav.user')}</span>
                                <span className="dn-ctx-val">{clientData?.name || 'Invitado'}</span>
                            </button>
                        ) : (
                            <NavLink
                                to={`/profile`} className={'position-relative text-decoration-none'}>
                                <button className="dn-ctx border">
                                    <Ico.User />
                                    <span className="dn-ctx-label">{t('nav.user')}</span>
                                    <span className="dn-ctx-val">{clientData ? clientData.name : 'Invitado'}</span>
                                </button>
                            </NavLink>
                        )
                    )
                    }

                </div>
                {/* ── CENTRO: links en cápsula flotante ── */}
                <nav className="dn-links" aria-label="Navegación principal">

                    {/* Navigation */}

                    {type === 'restaurant'
                        ? <></>
                        : <>


                            {!shouldHideNavbar && (PreOrder_id === null || showDirectOrderContext) && <SubMenuNav />}</>
                    }

                </nav>

                {/* ── DERECHA: acciones ── */}
                <div className="dn-right">
                    {/* Actions */}
                    <div className='' >
                        <EventSelector />
                    </div>
                    <LanguageSwitcher />
                    {!shouldHideNavbar && hasTableSession && (
                        <button
                            type="button"
                            className="dn-ctx border"
                            onClick={() => navigate('/cart')}
                        >
                            <i className="bi bi-receipt" />
                            <span className="dn-ctx-label">{t('nav.viewMyOrder')}</span>
                        </button>
                    )}
                    {!shouldHideNavbar && buttonShopavailable !== false && <BtnShoppingcartFloat datashoppingcart={shoppingcart} quoteData={quoteData} />}
                    {/* Mobile Toggle */}
                    <button className="mobile-toggle" onClick={toggleMenu}>
                        <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}></i>
                    </button>
                </div>
            </nav>

            {/* Mobile Menu */}
            <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
                <div className="mobile-nav">


                    {menuOptions.map((item, index) => (
                        <a
                            key={index} onClick={() => !item.subItems && navigate(item.path)}
                            className="nav-link-modern"

                        >
                            <i className={item.icon}></i>
                            <span onClick={closeMenu}>{item.label}</span>
                        </a>

                    ))}

                    <div className="nav-link-modern">
                        <LanguageSwitcher />
                    </div>
                </div>
            </div>

            {/* End New Menu */}

             <ContextBar /> 





        </>
    )
}

export default HeaderMain
